module.exports = __webpack_public_path__ + "img/0-lg.9d4a0426.jpg";